import registrationInstance from '../instance'

const fetchCompanyData = (companyIndex) => {
	return registrationInstance.get(`/admin/companies/${companyIndex}`)
}

export default fetchCompanyData
